import {
  Container,
  GridContainer,
  SectionRoot,
} from '@exploration/shared-components';
import { CTAWithImageSection } from '@exploration/shared-sections';
import { desktop } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import Image from 'next/image';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const DecisionsSectionStyles = {
  Section: styled(SectionRoot)``,
  SectionContainer: styled(Container)`
    display: flex;
    flex-direction: column;
    padding-top: 3rem;
    padding-bottom: 1.5rem;

    ${desktop} {
      padding-top: 5rem;
      padding-bottom: 3rem;
    }
  `,
  Headline: styled(MDSText.HeroMd)``,
  SubHeadline: styled(MDSText.BodyRegDefault)`
    max-width: 36.75rem;
    padding-top: 0.5rem;
  `,
  CTAContainer: styled(CTAWithImageSection)`
    ${GridContainer} {
      padding-bottom: 0;
    }
  `,
  ContentBox: styled.div``,
  ImageContent: styled.div`
    position: relative;
    height: 100%;
  `,
  StyledImage: styled(Image)`
    object-fit: cover;
    object-position: top center;
    z-index: 1;
    display: block;
    width: 100%;

    ${desktop} {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  `,
  ImageBanner: styled.div`
    z-index: 2;
    background-color: ${(p) => p.theme.midwestColors.neutralDarkStrong};

    ${desktop} {
      position: absolute;
      bottom: 0;
      left: 0;
      max-width: 13.5rem;
    }
  `,
  ImageBannerRight: styled.div`
    z-index: 2;
    background-color: ${(p) => p.theme.midwestColors.neutralDarkStrong};

    ${desktop} {
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 13.5rem;
    }
  `,
  ImageBannerClickable: styled.a`
    display: block;
    padding: 1.5rem;
    height: 100%;
    width: 100%;
    &:hover {
      text-decoration: none;
    }
    &:focus {
      text-decoration: none;
    }
  `,
  ImagePercentage: styled(MDSText.DataMd)`
    color: ${(p) => p.theme.midwestColors.identityBrandPrimaryWeak};
  `,
  ImageSubHeadline: styled(MDSText.BodyRegDefault)`
    display: block;
    color: ${(p) => p.theme.midwestColors.neutralLightWeak};
  `,
  ImageSpan: styled(MDSText.BodyHeavyDefault)`
    color: ${(p) => p.theme.midwestColors.identityBrandPrimaryWeak};
  `,
};
